import * as React from 'react';
import { DraggableAttributes, UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';

interface SortableEventReportWrapperProps {
  id: UniqueIdentifier;
  renderEventReport: (handleAttributes: DraggableAttributes, handleListeners: SyntheticListenerMap | undefined) => React.ReactNode;
}

function SortableEventReportWrapper({ id, renderEventReport }: SortableEventReportWrapperProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    isDragging,
  } = useSortable({ id });

  const style = {
    // transform: CSS.Transform.toString(transform),
    // transition,
    opacity: isDragging ? 0 : 1,
  };

  return (
    <div ref={setNodeRef} style={style}>
      {renderEventReport(attributes, listeners)}
    </div>
  );
}

export default SortableEventReportWrapper;
